import { useAppContext } from '../../Services/AppContext';
import { OrderItem } from './CaseChatEntry';

interface CaseChatEntryOrderItemProps {
	orderItem: OrderItem;
	orderId: string;
	key: string;
	showOrderItemPrice: boolean;
}

export default function CaseChatEntryOrderItem(
	props: CaseChatEntryOrderItemProps,
) {
	const { orderItem, showOrderItemPrice = false } = props;

	return (
		<div className='chat-message__order__body__item'>
			<div className='chat-message__order__body__item__title'>
				{orderItem.name}
			</div>
			{showOrderItemPrice && (
				<div className='chat-message__order__body__item__price'>
					{orderItem.price.formattedPrice}
				</div>
			)}
		</div>
	);
}
